<template>
  <v-container fluid>
    <V-row>
      <v-col md="12">
        <SettingItem
          @loadData="loadData"
          collection="coupons"
          :items="coupons"
          :itemHeader="couponItemHeader"
        />
      </v-col>
    </V-row>
  </v-container>
</template>

<script>
import SettingItem from "./SettingItem/index";
import ApiService from "@/services/api.service";

export default {
  components: {
    SettingItem,
  },
  data() {
    return {
      coupons: [],
      couponItemHeader: [
        { text: "code", value: "code" },
        { text: "status", value: "status" },
        { text: "for", value: "for" },
        { text: "Max", value: "user_max_num" },
        { text: "one user useage", value: "one_user_useage" },
        { text: "exp_date", value: "exp_date" },
        { text: "Actions", value: "actions", sortable: false },
      ],
    };
  },
  computed: {},
  methods: {
    async loadData() {
      try {
        this.loading = true;
        this.fetchData();
        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
    async fetchData() {
      try {
        const data = await ApiService.get(
          "items/coupons?fields=id,free_shipping,one_user_useage,code,status,category_id.id,tag_id.id,category_id.arabic_title,tag_id.arabic_title,product_id.id,product_id.arabic_title,user_max_num,start_date,exp_date,persentage,value"
        );
        let coupons = data.data.data;
        coupons.forEach((element) => {
          if (element.product_id) {
            element.for = element.product_id.arabic_title;
          } else {
            if (element.category_id) {
              element.for = element.category_id.arabic_title;

              if (element.tag_id) {
                element.for = element.for + " - ";
              }
            }
            if (element.tag_id) {
              element.for = element.for + element.tag_id.arabic_title;
            }
          }
        });
        this.coupons = coupons;
      } catch (error) {
        console.log(error);
      }
    },
  },
  mounted() {
    this.fetchData(undefined);
  },
};
</script>

<style></style>
